export default __webpack_public_path__ + "static/media/linkedin.5daab56c.png";